var DashboardToolbar, DashboardToolbarView, ProjectActions, ProjectStore, ReactComponent, View, alt, mediator,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

alt = require('alt');

ProjectActions = require('actions/project_actions');

ProjectStore = require('stores/project_store');

DashboardToolbar = require('components/dashboard/dashboard_toolbar');

mediator = require('mediator');

ReactComponent = require('base/lib/traits/react_component');

View = require('base/views/view');

module.exports = DashboardToolbarView = (function(_super) {
  __extends(DashboardToolbarView, _super);

  function DashboardToolbarView() {
    return DashboardToolbarView.__super__.constructor.apply(this, arguments);
  }

  DashboardToolbarView.prototype.container = '#toolbar-container';

  DashboardToolbarView.prototype.autoRender = true;

  DashboardToolbarView.prototype._stopInputsPropagation = false;

  DashboardToolbarView.prototype.initialize = function() {
    DashboardToolbarView.__super__.initialize.apply(this, arguments);
    return this.enable(ReactComponent);
  };

  DashboardToolbarView.prototype.afterRender = function() {
    DashboardToolbarView.__super__.afterRender.apply(this, arguments);
    return this.renderSimpleComponent(DashboardToolbar);
  };

  DashboardToolbarView.prototype.dispose = function() {
    this.unmountComponent();
    alt.recycle('ProjectStore');
    return DashboardToolbarView.__super__.dispose.apply(this, arguments);
  };

  return DashboardToolbarView;

})(View);
